import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from '../styles/Projects.module.css';

const ProjectCard = ({ project, onClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Get all media items
  const mediaItems = project.media && project.media.length > 0 
    ? project.media 
    : (project.image ? [project.image] : []);

  // Auto-loop carousel (pause on hover)
  useEffect(() => {
    if (mediaItems.length <= 1 || isHovered) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % mediaItems.length);
    }, 3000); // 3 seconds per image

    return () => clearInterval(interval);
  }, [mediaItems.length, isHovered]);

  return (
    <motion.article
      className={styles.projects__card}
      onClick={() => onClick(project)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5 }}
    >
      {/* 16:9 Image Container with Carousel */}
      <div className={styles.projects__image_wrapper}>
        <AnimatePresence mode="wait">
          <motion.img 
            key={currentIndex}
            src={mediaItems[currentIndex]} 
            alt={`${project.title} preview`}
            className={styles.projects__image}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          />
        </AnimatePresence>
        
        {/* Carousel Indicators */}
        {mediaItems.length > 1 && (
          <div className={styles.projects__indicators}>
            {mediaItems.map((_, idx) => (
              <span 
                key={idx} 
                className={`${styles.projects__indicator} ${idx === currentIndex ? styles.active : ''}`}
              />
            ))}
          </div>
        )}
        
        {/* Hover Overlay */}
        <div className={styles.projects__overlay}>
          <span className={styles.projects__view_text}>View Project</span>
        </div>
      </div>

      {/* Card Info */}
      <div className={styles.projects__info}>
        <h3 className={styles.projects__title}>{project.title}</h3>
        <p className={styles.projects__description}>{project.description}</p>
      </div>
    </motion.article>
  );
};

export default ProjectCard;
